<template>
  <van-field
    v-model="val"
    :disabled="disabled"
    :label="label"
    :placeholder="placeholder || label"
    :required="required"
    :rules="rules"
    :readonly="readonly"
    :clearable="clearable"
    @input="change"
    @focus="focus"
  />
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [{ required: this.required, message: this.msg }];
      }
    }
  },
  data() {
    return {
      val: this.value,
      msg: this.placeholder ? null : '请输入' + this.label
    };
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  },
  mounted() {

  },
  methods: {
    change(value) {
      this.$emit('change', value);
    },
    focus() {
      this.$emit('focus');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/base/BaseInput.vue